var map = {
	"./black/xiugaiyinliang.png": "UbOF",
	"./blue/xiugaiyinliang.png": "0sdB",
	"./white/xiugaiyinliang.png": "+yOn"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jcfo";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/xiugaiyinliang\.png$
// module id = jcfo
// module chunks = 24